import React, {FC, useState} from "react"

import {IconTypes} from "@irati/ui/src/Icon"
import {useTheme} from "@irati/ui/src/global/useTheme"
import Flex from "@irati/ui/src/Flex"
import {Body} from "@irati/ui/src/Typography"
import FormattedMessage, {InjectIntl, injectIntl} from "@irati/utils/lang"
import {ReportingCompanyBenefits} from "@irati/types"
import {adminDashboardTracking} from "@irati-tracking/admin"
import Widget from "../Widget"
import BoldNumberSmallText from "../BoldNumberSmallText"
import TopBenefit from "./TopBenefit"
import CompanyBenefitsModal from "./CompanyBenefitsModal"

interface Props extends InjectIntl {
  topCompanyBenefits: ReportingCompanyBenefits
}

const CompanyBenefitsWidget: FC<Props> = ({topCompanyBenefits, formatMessage}) => {
  const [showCompanyBenefitsModal, setShowCompanyBenefitsModal] = useState(false)
  const theme = useTheme()
  const hasBenefits = !!topCompanyBenefits?.benefits?.length
  const buttonText = hasBenefits
    ? "admin.components.dashboard.reporting.companyBenefits.buttonText"
    : "admin.components.dashboard.reporting.companyBenefits.empty.buttonText"

  const handleClick = () => {
    adminDashboardTracking.companyBenefitsInsights()
    setShowCompanyBenefitsModal(true)
  }

  return (
    <Widget
      title="admin.components.dashboard.reporting.companyBenefits.title"
      icon={IconTypes.heartOutline}
      buttonText={buttonText}
      onClick={handleClick}
      iconColor={theme.colors.tertiary.i_200}>
      {hasBenefits ? (
        <>
          <BoldNumberSmallText boldValue={topCompanyBenefits.redemptions} text="clicks" />
          <Flex marginTop={2} justifyContent="space-around">
            {topCompanyBenefits.benefits
              .filter((benefit) => benefit?.companyBenefit)
              .map((benefit, index) => (
                <TopBenefit ranking={index + 1} benefit={benefit} />
              ))}
          </Flex>
        </>
      ) : (
        <>
          <Flex justifyContent="center">
            <img
              height={100}
              width={100}
              src={formatMessage({id: "admin.components.dashboard.reporting.companyBenefits.img"})}
              alt="A woman reclines in a chair, resting her head against the back, appearing relaxed and contemplative."
            />
          </Flex>
          <Body small marginBottom={2}>
            <FormattedMessage id="admin.components.dashboard.reporting.companyBenefits.comingSoon.text" />
          </Body>
        </>
      )}
      <CompanyBenefitsModal show={showCompanyBenefitsModal} onHide={() => setShowCompanyBenefitsModal(false)} hasBenefits={hasBenefits} />
    </Widget>
  )
}

export default injectIntl(CompanyBenefitsWidget)
